import { useEffect } from "react";
import { useOnBoardingDashboardStyles } from "./OnBoardingDashboardStyles";
import WelcomeSection from "../WelcomeSection";
import RecommendedFeaturesSection from "../RecommendedFeaturesSection";
import { getRecentInteractionsCount, hasRecentActivitiesSelector } from 'slices/InteractionLogs/InteractionLogsSlice';
import { useAppDispatch, useAppSelector } from "@store";
import {  LIMIT_TO_DAYS } from 'const/recentActivities'
import { RecentActivities } from "../RecentInteractionLogs";

const OnBoardingDashboard = () => {
  const { classes } = useOnBoardingDashboardStyles();
  const dispatch = useAppDispatch();
  const hasRecentActivites = useAppSelector(hasRecentActivitiesSelector);

  
  useEffect(() => {
    dispatch(getRecentInteractionsCount({ limitToDays: LIMIT_TO_DAYS }));
  }, [])

  return (
    <div className={classes.root}>
      {
        hasRecentActivites === false && <WelcomeSection />
      }
      {
        hasRecentActivites && <RecentActivities />
      }
      <RecommendedFeaturesSection />
    </div>
  );
};

export default OnBoardingDashboard;
